import { ContractError, UnsupportedDeviceError } from "./activityAdapter";

// Backend failures reduced to what the learner screen needs to know.
export const OFFLINE = "offline";
export const DENIED = "denied";
export const UNAVAILABLE = "unavailable";
export const UNKNOWN = "unknown";
// The gateway is up but cannot reach Directus with its own access: a setup
// fault that no action on the tablet can fix.
export const SETUP = "setup";
// The tablet's browser is too old for this activity (contract-valid, but it
// needs exact numbers). Updating the browser fixes it.
export const UNSUPPORTED = "unsupported";

export const problemOf = (error) => {
  if (navigator.onLine === false || error instanceof TypeError) return OFFLINE;
  if (error instanceof UnsupportedDeviceError) return UNSUPPORTED;
  if (error instanceof ContractError) return UNAVAILABLE;
  const status = error?.response?.status;
  if (status === 401 || status === 403) return DENIED;
  if (status === 503) return SETUP;
  return UNKNOWN;
};
